import { createSlice } from '@reduxjs/toolkit';
const initialState = { keyword: '', data: [] };
const cannibalizationsModal = createSlice({
  name: 'cannibalizationsModal',
  initialState,
  reducers: {
    showCannibalizationsModal: (state, action) => {
      return action.payload;
    },
    hideCannibalizationsModal: state => {
      return initialState;
    }
  }
});
export const { showCannibalizationsModal, hideCannibalizationsModal } =
  cannibalizationsModal.actions;
export default cannibalizationsModal;
